import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "react-bootstrap/Form";
import { setInjuryType } from "../../../../redux/slice/QuickReportSlice";

const InjuryTypeSelect = () => {
  const dispatch = useDispatch();
  const { injuryType } = useSelector((state) => state.QUICKREPORT);

  const handleInjuryType = (e) => {
    const { value } = e.target;
    dispatch(setInjuryType(value));
  };

  return (
    <Form.Select
      className="custom-select-box"
      value={injuryType}
      name="injuryType"
      onChange={handleInjuryType}
    >
      <option value="" disabled className="option-title">
        How many injuries are being reported?
      </option>
      <option value="single">Single Injury</option>
      <option value="multiple">Multiple Injuries</option>
    </Form.Select>
  );
};

export default InjuryTypeSelect;
